/*!

=========================================================
* Argon Dashboard PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// react library for routing
import { Route, Switch } from "react-router-dom";

// core components
import Footer from "components/Footer.jsx";

import routes from "routes.js";

class Main extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      endpoint: 'https://rss.dpgmedia.nl/backend/'
      // endpoint: 'http://dpgrss.local/backend/'
    }
  }
  
  componentDidUpdate(e) {
    if (e.history.pathname !== e.location.pathname) {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainContent.scrollTop = 0;
    }
  }
  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }

      return (
        <Route
          path={prop.layout + prop.path}
          key={key}
          render={(props) => <prop.component {...props} generic={this.state} />}
        />
      );
    });
  }

  render() {
    return (
      <>
        <div className="main-content" ref="mainContent">
          <Switch>{this.getRoutes(routes)}</Switch>
        </div>
        <Footer location={this.props.location} />
      </>
    );
  }
}

export default Main;
